import React, { useEffect, useState } from 'react'
import isEmpty from 'lodash/isEmpty'
import intersection from 'lodash/intersection'
import styled from 'styled-components'

import ListItem from '@pc/components/Works/Panel/shared/list/ListItem'
import ListItemParagraph from '@pc/components/Works/Panel/shared/list/ListItemParagraph'
import ListItemName from '@pc/components/Works/Panel/shared/list/ListItemName'
import ListItemDescription from '@pc/components/Works/Panel/shared/list/ListItemDescription'
import LineList from './LineList'
import ListOpenIcon from '@pc/components/Works/Panel/shared/list/ListOpenIcon'
import ListCloseIcon from '@pc/components/Works/Panel/shared/list/ListCloseIcon'
import type { RawLineCompany, Line, Station } from '@pc/components/Works/Panel/type'

interface PropsType {
  lineCompany: RawLineCompany
  lines: Line[]
  mappedStations: Record<string, Station[]>
  selectedStationIds: string[]
  changeStationIds: (stationIds: string[]) => void
}

const LineListWrapper = styled.ul`
  width: 100%;
`

const LineCompanyListItem = styled(ListItem)`
  cursor: pointer;
`

const LineCompanyListItemParagraph = styled(ListItemParagraph)<{ $enable: boolean }>`
  ${(props) => Boolean(props.$enable) && 'background-color: #f5f5f5;'}
  ${(props) => Boolean(props.$enable) && 'border-bottom: 1px solid #ccc;'}
  display: flex;
  position: relative;
  width: 100%;

  svg {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
  }
`

const LineCompanyListItemName = styled(ListItemName)`
  font-weight: bold;
  min-width: 170px;
`

const LineCompanyListDescription = styled(ListItemDescription)`
  margin-right: 30px;
`

const LineCompanyItem = (props: PropsType) => {
  const { lineCompany, lines, mappedStations, selectedStationIds, changeStationIds } = props
  const [childrenIsOpen, setChildrenIsOpen] = useState(false)

  const isSelectedBeforehand = () => {
    const { lines, mappedStations, selectedStationIds } = props
    const stationIdsInLineCompanies = lines
      .map((line) => {
        const stations = mappedStations[line.id]
        return stations.map((station) => station.attributes.compat_id.toString())
      })
      .flat()
    return !isEmpty(intersection(stationIdsInLineCompanies, selectedStationIds))
  }

  const toggleChildren = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault()
    setChildrenIsOpen(!childrenIsOpen)
  }

  const joinLineNames = (lines: Line[]) => {
    return lines.map((line) => line.attributes.name).join('、')
  }

  useEffect(() => {
    if (isSelectedBeforehand()) {
      setChildrenIsOpen(true)
    }
  }, [])

  return (
    <LineCompanyListItem>
      <LineCompanyListItemParagraph onClick={toggleChildren} $enable={childrenIsOpen}>
        <LineCompanyListItemName>{lineCompany.attributes.name}</LineCompanyListItemName>
        <LineCompanyListDescription>{joinLineNames(lines)}</LineCompanyListDescription>
        {childrenIsOpen ? <ListCloseIcon /> : <ListOpenIcon />}
      </LineCompanyListItemParagraph>
      <LineListWrapper>
        {childrenIsOpen ? (
          <LineList lines={lines} mappedStations={mappedStations} selectedStationIds={selectedStationIds} changeStationIds={changeStationIds} />
        ) : null}
      </LineListWrapper>
    </LineCompanyListItem>
  )
}

export default LineCompanyItem
